import React, { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faAngleDown,
  faAngleUp,
  faArrowDown,
  faArrowUp,
  faEdit,
  faArrowLeft,
  faEllipsisH,
  faExternalLinkAlt,
  faEye,
  faTrashAlt,
} from "@fortawesome/free-solid-svg-icons";
import {
  Col,
  Row,
  Nav,
  Card,
  Image,
  Button,
  Table,
  Dropdown,
  ProgressBar,
  Pagination,
  ButtonGroup,
} from "@themesberg/react-bootstrap";
import { Link } from "react-router-dom";
import { useHistory } from "react-router-dom";
import { Routes } from "../routes";
import transactions from "../data/transactions";
import commands from "../data/commands";
import { useParams } from "react-router-dom";
import Chartist from "react-chartist";
import Legend from "chartist-plugin-legend";
import ChartistTooltip from "chartist-plugin-tooltips-updated";
import BulFlag from "./bulgaria.png";
import db from "./firebase.config.js";
import moment from "moment";
import "moment/locale/bg";
import {
  faAngleDoubleLeft,
  faAngleDoubleRight,
} from "@fortawesome/free-solid-svg-icons";
import CanadaFlag from "../assets/img/flags/bulgaria.svg";
import DefaultPic from "./pic.webp";
import ReactLoading from "react-loading";
const Change = ({ change }) => {
  let bounceIcon = change < 0 ? faArrowDown : faArrowLeft;
  let bounceTxtColor = change < 0 ? "text-danger" : "text-success";
  let prefix = change > 0 ? "+" : "";
  if (change > 0) {
    bounceIcon = faArrowUp;
    bounceTxtColor = "text-success";
    prefix = "+";
  } else if (change < 0) {
    bounceIcon = faArrowDown;
    bounceTxtColor = "text-danger";
  } else {
    bounceIcon = faArrowLeft;
    bounceTxtColor = "text-grey";
    prefix = " ";
  }
  return (
    <span className={`${bounceTxtColor} `}>
      <FontAwesomeIcon icon={bounceIcon} className={`${bounceTxtColor} me-3`} />
      {prefix} {change}
    </span>
  );
};

const ChangeProfile = ({ change }) => {
  let bounceIcon = change < 0 ? faArrowDown : faArrowLeft;
  let bounceTxtColor = change < 0 ? "text-danger" : "text-success";
  let prefix = change > 0 ? "+" : "";
  let border;
  if (change > 0) {
    bounceIcon = faArrowUp;
    bounceTxtColor = "text-success";
    prefix = "+";
    border = "border-diff-w";
  } else if (change < 0) {
    bounceIcon = faArrowDown;
    bounceTxtColor = "text-danger";
    prefix = "-";
    border = "border-diff-l";
  } else {
    bounceIcon = faArrowLeft;
    bounceTxtColor = "text-grey";
    prefix = " ";
    border = "border-diff-n";
  }
  let absoluteChange = Math.abs(change);
  return (
    <div className={`${border} ${bounceTxtColor}`}>
      <span className={`ver-align`}>
        <span className={`${bounceTxtColor} text-size-40`}>
          {prefix}
          {absoluteChange}
        </span>

        <FontAwesomeIcon
          icon={bounceIcon}
          className={`${bounceTxtColor} me-3 fa-2x`}
        />
      </span>
    </div>
  );
};

export const SalesValueChart = (props) => {
  let time = [];
  let seriesa = [];

  for (let k = props.data.length - 1; k >= 0; k--) {
    let index;
    if (props.data[k].Players[0] === props.id) {
      index = 0;
    } else {
      index = 1;
    }
    let t = new Date(1970, 0, 1);

    t.setSeconds(props.data[k].date.seconds);

    seriesa.push(props.data[k].elo[index]);
    time.push(t);
    if (k === 0) {
      let t = new Date(1970, 0, 1);
      t.setSeconds(props.data[k].date.seconds);
      seriesa.push(props.player.elo);
      time.push(t);
    }
  }

  const data = {
    labels: time,
    series: [seriesa],
  };

  const options = {
    fullWidth: true,

    seriesBarDistance: 10,
    type: Chartist.FixedScaleAxis,
    scaleShowLabels: false,
    showPoint: false,

    axisX: {
      showGrid: false,
      labelInterpolationFnc: function (value, index, labels) {
        const leb = Math.floor(labels.length / 6);
        if (labels.length >= 49) {
          if (index === leb * 6) {
            return null;
          }
          return index % leb === 0 ? moment(value).format("l") : null;
        } else if (leb >= 3) {
          if (index === labels.length - 1 || index === 0) {
            return null;
          }
          return index % leb === 0 ? moment(value).format("l") : null;
        } else if (leb === 2) {
          console.log(index);
          if (index === labels.length - 2 || index === 0) {
            return null;
          }

          return index % 2 === 0 ? moment(value).format("l") : null;
        } else if (leb === 1) {
          if (index === labels.length - 1) {
            return null;
          }
          if (labels.length)
            return index % 2 === 0 ? moment(value).format("l") : null;
        } else {
          if (labels.length - 1 === index) return null;
          return moment(value).format("l");
        }
      },
    },
    axisY: {
      // On the y-axis start means left and end means right
      labelInterpolationFnc: function (value, index, labels) {
        const leb = Math.floor(labels.length / 5);
        if (labels.length > 5) {
          return index % leb === 0 ? Math.floor(value) : null;
        } else {
          return value;
        }
      },
      showGrid: true,
      howGrid: true,
      showLabel: true,
    },
  };

  const plugins = [ChartistTooltip()];

  return (
    <Chartist
      data={data}
      options={{ ...options, plugins }}
      type='Line'
      className='ct-chart ct-golden-section margin-bot'
    />
  );
};

export const Piechart = (props) => {
  var data = {
    labels: ["Победи", "Загуби"],
    series: [props.x, props.y],
  };
  const k = Math.round(props.x);
  var options = {
    labelInterpolationFnc: function (value) {
      return value[0];
    },
    showLabel: false,
  };

  var responsiveOptions = [
    [
      "screen and (min-width: 640px)",
      {
        chartPadding: 30,
        labelOffset: 100,
        labelDirection: "explode",
        labelInterpolationFnc: function (value) {
          return value;
        },
      },
    ],
    [
      "screen and (min-width: 1024px)",
      {
        labelOffset: 80,
        chartPadding: 20,
      },
    ],
  ];
  const plugins = [Legend({ clickable: false })];

  return (
    <Chartist
      data={data}
      responsive-options={responsiveOptions}
      options={{ ...options, plugins }}
      type={"Pie"}
      className='.ct-chart pie-size'
    />
  );
};

export const GraphDisplay = (props) => {
  const l = props.data.length;

  const [displayMatches, setDisplayMatches] = useState([
    "secondary",
    "secondary",
    "primary",
  ]);
  const [displayData, setdisplayData] = useState([]);
  const [winrate, setWinrate] = useState(0);
  const [lossrate, setLossrate] = useState(0);
  const [elo_diff, setElo_diff] = useState(0);
  const [loading, setLoading] = useState(false);

  const calcWinrate = (sizeArr1) => {
    let k = 0;
    let sizeArr = displayData.length;
    for (let i = 0; i < sizeArr; i++) {
      if (props.player_data.id === props.data[i].Players[0]) {
        k++;
      }
    }
    let winRate = (k / sizeArr) * 100;
    let lossRate = ((sizeArr - k) / sizeArr) * 100;

    return [winRate, lossRate];
  };
  const calculateElo = () => {
    let index;
    let l = displayData.length;
    if (props.id === props.data[l - 1].Players[0]) index = 0;
    else index = 1;
    setElo_diff(props.player_data.elo - props.data[l - 1].elo[index]);
  };

  const handleDisplayMatches = (value) => {
    let arr = [];
    for (let k = 0; k < 3; k++) {
      if (k == value.target.value) {
        arr.push("primary");
      } else {
        arr.push("secondary");
      }
    }
    setDisplayMatches(arr);

    if (value.target.value == 0) {
      setdisplayData(props.data);
      let sizeArr = props.data.length;
      let res = calcWinrate(sizeArr);
      calculateElo();

      setWinrate(res[0]);
      setLossrate(res[1]);
    } else if (value.target.value == 1) {
      setdisplayData(props.data.slice(0, 50));
      let res = calcWinrate(50);

      calculateElo();

      setWinrate(res[0]);
      setLossrate(res[1]);
    } else {
      setdisplayData(props.data.slice(0, 15));
      let res = calcWinrate(15);
      calculateElo();

      setWinrate(res[0]);
      setLossrate(res[1]);
    }
  };

  useEffect(() => {
    let res = [0, 0];
    setdisplayData(props.data.slice(0, 15));
    setLoading(true);
  }, [props.data]);

  useEffect(() => {
    if (loading === true) {
      let res = calcWinrate(15);
      setWinrate(res[0]);
      setLossrate(res[1]);

      calculateElo();
    }
  }, [displayData]);

  let stylebutton1, stylebutton2, stylebutton3;
  if (displayMatches[0] === "primary") {
    stylebutton1 = " button-graph-style onbut text-size-20 margin-right-2";
    stylebutton2 = " button-graph-style margin-right-2 margin-left-2 ";
    stylebutton3 = " button-graph-style margin-left-2";
  } else if (displayMatches[1] === "primary") {
    stylebutton1 = " button-graph-style margin-right-2";
    stylebutton2 =
      " button-graph-style onbut text-size-20 margin-right-2 margin-left-2 ";
    stylebutton3 = " button-graph-style margin-left-2";
  } else {
    stylebutton1 = " button-graph-style margin-right-2";
    stylebutton2 = " button-graph-style  margin-right-2 margin-left-2";
    stylebutton3 = " button-graph-style onbut text-size-20 margin-left-2";
  }

  const percentageIcon = elo_diff < 0 ? faAngleDown : faAngleUp;
  const percentageColor = elo_diff < 0 ? "text-danger" : "text-success";

  return (
    <div>
      <div>
        <div className='container white'>
          <ul className='tabs'>
            <li className=''>
              <Link to='/'>Начало</Link>
            </li>
            <li className=''>
              <Link to='/ranking'>Ранкинг</Link>
            </li>
          </ul>

          <div className='rank-item1'>
            <div className='rank-player'>
              <div className='rank-player_rank'>
                <Image
                  src={DefaultPic}
                  className='image-md me-2  image-rm margin-top-7px'
                />
              </div>
              <div className='rank-player__name'>
                <div>
                  <img
                    src={BulFlag}
                    alt='bul'
                    className='bornan-flag bornan-flag-sm'
                  />
                  <span className='org'>BUL</span>
                  <span>
                    {props.player_data.name} {props.player_data.lastName}
                  </span>
                </div>
                <div>
                  <span className='text-orange'>
                    {props.player_data.elo} Rating
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className='container'>
          <h3 className='text-align-center text-size-24 '>Статистика</h3>
        </div>

        <div className='buttons-graph'>
          <button
            value={0}
            onClick={handleDisplayMatches}
            className={stylebutton1}>
            Всички мачове
          </button>

          <button
            value={1}
            onClick={handleDisplayMatches}
            className={stylebutton2}>
            Последните 50 Мача
          </button>

          <button
            value={2}
            onClick={handleDisplayMatches}
            className={stylebutton3}>
            Последните 15 Мача
          </button>
        </div>

        <div className='container white'>
          <div className='statistics'>
            <div className='column-stat'>
              <div>
                <div className='text-align-center'>
                  {" "}
                  Последните {displayData.length} Мача:
                </div>
                <div className='elo_diff'>
                  <ChangeProfile change={elo_diff}> </ChangeProfile>
                </div>
              </div>
              <Piechart x={winrate} y={lossrate} />
            </div>
          </div>
        </div>
      </div>

      <div className='container '>
        <h3 className='text-align-center text-size-24 '>
          Състезателен Реийтинг
        </h3>
      </div>
      <div className='container white'>
        <div className='results-table'>
          <div className='text-align-center padding'>
            <SalesValueChart
              data={displayData}
              player={props.player_data}
              id={props.id}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export const PageTrafficTable = () => {
  const [loading, setLoading] = useState(true);
  const [matches, setMatches] = useState([]);
  const [player, setPlayer] = useState({});
  let { id } = useParams();
  const [load, setLoad] = useState(id);
  const history = useHistory();

  const fetchMatches = async () => {
    setMatches([]);
    if (id) {
      const response = db
        .collection("matches")
        .where("Players", "array-contains", id)
        .orderBy("date", "asc");
      const data = await response.get();
      data.docs.forEach((item) => {
        setMatches((matches) => [item.data(), ...matches]);
      });
    }
    setLoading((state) => !state);
  };

  const fetchPlayer = async () => {
    setPlayer({});
    if (id) {
      const player_req = db.collection("players").doc(id);
      const player_data = await player_req.get();
      const player_extract = player_data.data();
      setPlayer(player_extract);
    }
  };
  useEffect(() => {
    fetchPlayer();
    fetchMatches();
  }, [load]);

  window.onpopstate = (e) => {
    let loc = history.location.pathname;
    id = loc.slice(8);
    fetchPlayer();
    fetchMatches();
    //your code...
  };
  window.onpushstate = (e) => {
    //your code...
  };

  const [activeItem, setActiveItem] = React.useState(0);
  const resultsPerPage = 15;
  const totalPages = Math.ceil(matches.length / resultsPerPage);

  const onPrevItem = () => {
    const prevActiveItem = activeItem === 0 ? activeItem : activeItem - 1;
    setActiveItem(prevActiveItem);
  };

  const onNextItem = (totalPages) => {
    const nextActiveItem =
      activeItem === totalPages ? activeItem : activeItem + 1;
    setActiveItem(nextActiveItem);
  };

  const ReportMatches = (props) => {
    const a = props.date.toDate();

    const l = moment(a, "ddd MM DD YYYY HH:mm:ss").format("LL");

    return (
      <div className='container white'>
        <div className='results-item'>
          <div className='top-info'>
            <div className='main-info'>
              <span>Table Tennis Center Mall Varna - Турнир "Приятели"</span>
            </div>
          </div>
          <div className='top-info'>
            <div className='main-info'>Официален Maч</div>
            <div className='table-name'>{l}</div>
          </div>
          <div className='match-item'>
            <div className='score-info'>
              <div className='player-info sel'>
                <div className='winner'>
                  <span>WIN</span>
                </div>
                <ul className='name'>
                  <li>
                    <span className='country'>
                      <i className='fa fa-user-circle bornan-flag' />
                    </span>
                    <a className='m-r-4 text-lgreen'>{props.Players_name[0]}</a>
                    &nbsp;BUL ({props.elo[0]})
                  </li>
                </ul>
              </div>
              <div className='score-data'>
                <div className='score-item score-total'>
                  <span>{props.score[0]}</span>
                </div>
                <div class='score-item score-total'>
                  <span>
                    <Change change={props.elo_change[0]}> </Change>
                  </span>
                </div>
              </div>
            </div>
            <div class='score-info'>
              <div class='player-info hide-mobile'>
                <div class='winner'></div>
                <ul class='name'>
                  <li>
                    <span class='country'>
                      <i class='fa fa-user-circle bornan-flag' />
                    </span>
                    <a className='m-r-4 text-danger'>{props.Players_name[1]}</a>
                    &nbsp;BUL ({props.elo[1]})
                  </li>
                </ul>
              </div>
              <div class='score-data'>
                <div class='score-item score-total'>
                  <span>{props.score[1]}</span>
                </div>
                <div class='score-item score-total'>
                  <span>
                    <Change change={props.elo_change[1]}> </Change>
                  </span>
                </div>
              </div>
              <div class='player-info show-mobile'>
                <div class='winner'></div>
                <ul class='name'>
                  <li>
                    <span class='country'>
                      <i class='fa fa-user-circle bornan-flag' />
                    </span>
                    <a className='m-r-4 text-danger'>{props.Players_name[1]}</a>
                    &nbsp;BUL ({props.elo[1]})
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };
  let items = [];
  for (let number = 0; number < totalPages; number++) {
    let isItemActive;
    if (activeItem === number) isItemActive = "page-item active";
    else {
      isItemActive = "page-item";
    }

    const handlePaginationChange = () => {
      setActiveItem(number);
    };

    items.push(
      <li
        className={isItemActive}
        key={number}
        onClick={handlePaginationChange}>
        <a>{number}</a>
      </li>
    );
  }

  return (
    <div>
      {loading ? (
        <div>
          <ReactLoading
            type={"spin"}
            className={"loading-home"}
            color={"orange"}
            height={50}
            width={50}
            name={"Loading..."}
          />
          <h5 className={"loading-text"}>Loading...</h5>
        </div>
      ) : (
        <GraphDisplay data={matches} player_data={player} id={id} />
      )}

      {loading ? (
        ""
      ) : (
        <Card.Header className='container'>
          <Row>
            <h3 className='text-align-center text-size-24 '>Мачове</h3>
          </Row>
        </Card.Header>
      )}

      <div className='results-table'>
        {loading
          ? ""
          : matches
              .slice(
                activeItem * resultsPerPage,
                activeItem * resultsPerPage + resultsPerPage
              )
              .map((pt) => (
                <ReportMatches
                  key={`page-traffic-${pt.date.toDate()}`}
                  {...pt}
                />
              ))}
      </div>

      {loading ? (
        ""
      ) : (
        <div className='paginator'>
          <div className='paginator__display'>
            <span>
              Показва{" "}
              {resultsPerPage > matches.length
                ? matches.length
                : resultsPerPage}{" "}
              от общо {matches.length} мача.
            </span>
          </div>
          <nav className='nav-pagination'>
            <ul className='pagination'>{items}</ul>
          </nav>
        </div>
      )}
    </div>
  );
};
